module.exports = __webpack_public_path__ + "static/piscine-56853f9e6e70a066aff32f3c66e57c32.jpg";